import useDebounce from '@/common/hooks/useDebounce.ts';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type.ts';
import { getIncidentTypes } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/incidentDetailsCauseQueryProperty.ts';
import { fileDetailQueryOption } from '@/modules/FileList/queries/fileDetail/fileDetailQueryOption';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

const useIncidentDetailsCauses = (id: string) => {
  const [incidentDetail, setIncidentDetail] = useState<string>('');
  const { data: fileDetail, isSuccess } = useQuery(
    fileDetailQueryOption({ id: +id }),
  );

  const debounce = useDebounce();
  const onIncidentDetailsChange = (value: string) => {
    if (value) {
      debounce(() => {
        setIncidentDetail(value);
      }, 1000);
    } else {
      setIncidentDetail(value);
    }
  };
  const { data: incidentCauseData, isPending: incidentCausePending } = useQuery(
    {
      queryKey: ['incidentCause', incidentDetail],
      queryFn: () =>
        getIncidentTypes({
          fa_name: incidentDetail,
          insurance: fileDetail?.insurance!,
        }),
      enabled: isSuccess,
      select: (data): SelectionOptionsType[] =>
        data.map((item) => ({
          label: item.name,
          value: item.id,
        })),
    },
  );

  return { incidentCauseData, incidentCausePending, onIncidentDetailsChange };
};

export default useIncidentDetailsCauses;
